import React from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.css"
// import { useAuth } from "../../hooks/useAuth";
import { ReactComponent as UserIcon } from "../../assets/user-icon.svg"
import { ReactComponent as LeftChevron } from "../../assets/left-chevron-icon.svg"
import { NAVIGATION_ROUTES } from "../../constant";
import { Link } from "react-router-dom";
import { useTokenStore } from "../../storage/tokenState";
import _isEmpty from "lodash/isEmpty";
import { SCREEN_NAMES } from "../../utils/helpers/constants";
import { useGoogleLoginApi } from "../../api/useGoogleLoginApi";
import Loader from "../../components/Loader";
import { GoogleLogin } from "@react-oauth/google";
import { useConfigStore } from "../../storage/configState";
import { useUserStore } from "../../storage/userState";
import Skeleton from "../../components/Skeleton";


const UserItem: React.FC = () => {
  const { t } = useTranslation();
  const { token: userToken } = useTokenStore();
  const { signupPhoneNumber } = userToken;
  const { handlePPLogin, isLoading, isEnabled, setIsEnabled, setIsLoading, login } = useGoogleLoginApi();
  const { zupeePPEnabled = false } = useConfigStore.getState()?.preSignupConfig || {};
  const preProdEnvironmentLogin = () => zupeePPEnabled ? handlePPLogin() : null
  const { userDetails } = useUserStore();

  const handleSuccess = (credentialResponse: any) => {
    login.onSuccess(credentialResponse);
  };

  const handleClick = () => {
    setIsLoading(true);
    console.log("clicked");
    setTimeout(() => {
      setIsEnabled(false);
      setIsLoading(false);
    }, 1000);
  }

  const handleError = () => {
    login.onError();
    console.error('Login Failed');
  };

  return (
    <>
      {isLoading && <Loader transparent />}
      <div className={clsx(styles.userItemContainer)}>
        <div className={clsx(styles.contentBox)}>
          <div className={clsx(styles.iconBox)} onClick={() => preProdEnvironmentLogin()}>
            {!userDetails || !userDetails.profilePic ? <UserIcon /> : <img className={clsx(styles.userIcon)} src={userDetails?.profilePic} />
            }            {
              isEnabled && (
                <GoogleLogin onSuccess={handleSuccess} onError={handleError} click_listener={() => handleClick()} containerProps={{ className: clsx(styles.googleLoginBox) }} />
              )
            }
          </div>
          {!_isEmpty(userToken)
            ?
            <div className={clsx(styles.nonLoggedInUserCase)}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <span className={clsx(styles.phoneLabel, "fontSizeSm12 fontColor666 fontWeightRegular")}>
                  {t("nameText")} :
                </span>
                {!userDetails ? (
                  <Skeleton variant="sm-text" height="8px" width="80px" />
                ) : (
                  <span className={clsx(styles.phoneNo, "fontSizeSm12 fontColor666 fontWeightRegular")}  >
                    {userDetails?.name}
                  </span>
                )}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <span className={clsx(styles.phoneLabel, "fontSizeSm12 fontColor666 fontWeightRegular")}>
                  {t("phoneText")} :
                </span>
                {!userDetails ? (
                  <Skeleton variant="sm-text" height="8px" width="80px" />
                ) : (
                  <span className={clsx(styles.phoneNo, "fontSizeSm12 fontColor666 fontWeightRegular")}>
                    {userDetails?.phone}
                  </span>
                )}
              </div>
            </div>
            :
            <Link to={NAVIGATION_ROUTES.SIGNIN} state={{ screenName: SCREEN_NAMES.SETTINGS }} className={clsx(styles.loggedInUserCase)}>
              <span className={clsx(styles.signupLabel, "fontSizeSm12 fontColorSecondary fontWeightBold")}>{t("signUp")}</span>
              <LeftChevron />
            </Link>
          }
        </div>

      </div>
    </>
  )
}
export default UserItem;